import React, { useEffect, useState } from 'react';

import {
  getFollowers,
  getFollowersCountAction,
} from '../../../../modules/FollowersList/Artisan/Actions';
import {
  artisansAsLabelAndValueSelector,
  artisansIsLoadingSelector,
  artisansCountSelector,
} from '../../../../modules/FollowersList/Artisan/Selectors';
import { connect } from 'react-redux';
import List from '../../../../components/Lists/List';
import ListItem from '../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { artisanDataSelector } from '../../../../modules/auth/Selectors';
import getLangData from '../../../../utils/getLangData';

const FollowerList = (props) => {
  const {
    followerList,
    followerCount,
    isLoading,
    getFollowers,
    getFollowerCount,
    artisanData
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  // for testing only
  const artisanId = artisanData._id;

  useEffect(() => {
    getFollowers({ artisanId });
    getFollowerCount({ artisanId });
    // console.log(followerList)
  }, [getFollowerCount, getFollowers]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (followerList.length >= followerCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getFollowers({
      size,
      offset: followerList.length,
      // searchTerm: searchValue,
    });
  };
  const lang = getLangData().general_words
  //
  const dataLength =
    followerList.length <= followerCount ? followerList.length : followerCount;

  return (
    <InfiniteScroll next={fetchMore} hasMore={hasMore} dataLength={dataLength}>
      <List
        isLoading={isLoading}
        items={followerList}
        header={{ items: [lang.followers_name, lang.followers_email] }}
      >
        {followerList.map(({ firstName, _id, lastName, logo, email }) => (
          <ListItem
            type="multi"
            logo={logo}
            key={_id}
            data={[`${firstName} ${lastName}`, email]}
            name={`${firstName} ${lastName}`}
            // editLink={`/artisan-products/${_id}`}
            /* onDelete={() => deleteTag(_id)} */
            disable
          >{console.log(logo)}</ListItem>
        ))}
      </List>
    </InfiniteScroll>
  );
};

const mapStateToProps = (state) => ({
  followerList: artisansAsLabelAndValueSelector(state),
  followerCount: artisansCountSelector(state),
  isLoading: artisansIsLoadingSelector(state),
  artisanData: artisanDataSelector(state)
});

export default connect(mapStateToProps, {
  getFollowers: getFollowers,
  getFollowerCount: getFollowersCountAction,
})(FollowerList);
